import React from "react";
import numbro from "numbro";


export function toPercent(rowValue) {
  return numbro(rowValue).format({ output: "percent", mantissa: 1, thousandSeparated: true });
}

export function toCurrencyAndThousand(rowValue, currency="$") {
  return numbro(rowValue).formatCurrency({ thousandSeparated: true, currencySymbol: currency });
}

export const dataForStudioInfoTables = {
  tableFilter: false,
  overrideColumnCallback: header => ({ _style: header === "Revenue_url" ? { display: "none" } : {} }),
  scopedSlots: {
    Revenue_url: () => <td style={{ display: "none" }} />,
    Revenue: (item) => {
      const revenue = toCurrencyAndThousand(item.Revenue, "$");
      return <td>
        <a href={item.Revenue_url} target="_blank">{revenue}</a>
      </td>;
    }
  }
};
